import { UserRolesEnum } from '../enums/user-roles.enum';

export const getEstateUnitEmptyMessage = (
  userRole?: string,
  userEstateUnitId?: string | null
): string | undefined => {
  if (userRole === UserRolesEnum.estateUser && userEstateUnitId) {
    return 'Nenhum registro nesta unidade';
  }

  return undefined;
};

export const getListEmptyMessage = (
  userRole?: string,
  userEstateUnitId?: string | null
): string =>
  getEstateUnitEmptyMessage(userRole, userEstateUnitId) ??
  'Nenhum registro encontrado';
